export const RECIPE_CAPTURE_COPY = Object.freeze({
  url: Object.freeze({
    loadingHeading: "Finding recipe details…",
    loadingHelper: "Evercooked is looking for recipe details on the page for your review.",
    requestErrorHeading: "Something went wrong while reading the recipe details.",
    retryLabel: "Try another URL"
  }),
  text: Object.freeze({
    loadingHeading: "Organizing recipe text…",
    loadingHelper: "Evercooked is organizing the details for you to review.",
    requestErrorHeading: "We couldn't organize that recipe text",
    retryLabel: "Try another recipe text"
  })
})
